import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Accordion} from 'react-bootstrap';

// Elements
import LatestNewsSection from "../elements/latest-news-slider";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";

class Faq extends Component{
	
	render(){
		return (
			<>
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1 className=''>FAQ's</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Home</Link></li>
											<li className="breadcrumb-item active" aria-current="page">FAQ's</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>
					
					<section >
						<div className="container">
							<div className="row">
								<div className="col-lg-6">
									<Accordion className="accordion ttr-accordion1">
										<Accordion.Item eventKey="0">
											<Accordion.Header>What services are provided by Avenra Health Center?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">We offer a full range of healthcare services, encompassing General Medicine, Pediatrics, Physiotherapy, Diagnostic Tests, Preventive Checkups, and Specialized Consultations. Our aim is to enhance your health at every stage of life.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="1">
											<Accordion.Header>How do I schedule an appointment?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">To schedule an appointment, you can either call us directly or utilize our online booking system available on the website. Just choose your desired department and doctor, enter your information, and we will promptly confirm your appointment.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="2">
											<Accordion.Header>Who are the physicians at Avenra Health Center?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Our skilled team comprises Dr. Ananya Sharma (General Medicine & Preventive Care), Dr. Arjun Mehra (Physiotherapy & Diagnostics), and Dr. Priya Nair (Pediatrics & Specialized Consultations), among others.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="3">
											<Accordion.Header>Does Avenra Health Center manage emergency situations?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">We offer emergency support and prompt medical assistance around the clock to make sure you receive the necessary care at critical times.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="4">
											<Accordion.Header>What technology is utilized by the hospital?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">We utilize cutting-edge medical equipment and advanced technology to guarantee precise diagnostics and effective treatment plans.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="5">
											<Accordion.Header>Are preventive check-ups accessible?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Absolutely, we provide thorough preventive checkups aimed at identifying health concerns early on and assisting you in achieving optimal health.</p>
											</Accordion.Body>
										</Accordion.Item>
									</Accordion>
								</div>
								<div className="col-lg-6">
									<Accordion className="accordion ttr-accordion1">
										<Accordion.Item eventKey="0">
											<Accordion.Header>What is the level of experience of the doctors?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Our physicians possess extensive qualifications and years of experience in their specialties, committed to delivering tailored and empathetic care.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="1">
											<Accordion.Header>Is it possible to receive specialized consultations at Avenra?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Certainly. We provide access to specialized doctors for chronic and advanced medical care tailored to your individual health requirements.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="2">
											<Accordion.Header>What sets Avenra Health Center apart?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">We integrate advanced technology with empathetic care, providing tailored treatment plans and a friendly atmosphere for you and your loved ones.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="3">
											<Accordion.Header>What items should I prepare for my appointment?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Make sure to bring a valid identification, any prior medical reports or test results, your current medications, and your insurance information if you have it.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="4">
											<Accordion.Header>Do you provide pediatric services for infants and children?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Indeed, Dr. Priya Nair and our pediatric team are dedicated to providing care for infants, children, and adolescents, emphasizing their health and development.</p>
											</Accordion.Body>
										</Accordion.Item>
										<Accordion.Item eventKey="5">
											<Accordion.Header>Is there parking available at Avenra Health Center?</Accordion.Header>
											<Accordion.Body>
												<p className="mb-0">Certainly, we offer plenty of parking options for both patients and visitors to guarantee a comfortable and easy visit.</p>
											</Accordion.Body>
										</Accordion.Item>
									</Accordion>
								</div>
							</div>
						</div>
					</section>
					
					{/* <LatestNewsSection /> */}
					
				</div>
			
			</>
		);
	}
}

export default Faq;